import { render, staticRenderFns } from "./qiaoLiangTaiZhang.vue?vue&type=template&id=3c6dd1f9&scoped=true&"
import script from "./qiaoLiangTaiZhang.vue?vue&type=script&lang=js&"
export * from "./qiaoLiangTaiZhang.vue?vue&type=script&lang=js&"
import style0 from "./qiaoLiangTaiZhang.vue?vue&type=style&index=0&id=3c6dd1f9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6dd1f9",
  null
  
)

export default component.exports